











































































import { ref, defineComponent, watch } from '@vue/composition-api';

import { useScreenWidth, useRouter } from '@ideavivat/vivat-2';

const PartOfSidebarMenu = defineComponent({
  setup(props, ctx) {
    const state = ref('gray');

    function resetScrollPosition() {
      window.scrollTo(0, 0);
    }

    const { route } = useRouter();
    watch(route, () => { if ('input' in ctx.listeners) ctx.emit('input', ''); });

    const { isMobile, isTablet } = useScreenWidth();

    const menuClickHandler = () => {
      if ('click' in ctx.listeners) ctx.emit('click');
      if ('input' in ctx.listeners) {
        if (props.value === props.name) ctx.emit('input', '');
        else ctx.emit('input', props.name);
      }
    };
    const menuCloseHandler = () => {
      if ('input' in ctx.listeners) ctx.emit('input', '');
    };

    return {
      isExpandMenuMini: isMobile || isTablet,
      resetScrollPosition,
      state,

      menuClickHandler,
      menuCloseHandler,
    };
  },
  props: {
    icon: {},
    name: {},
    to: {
      type: [String, Object],
      default: '',
    },
    active: {
      type: Boolean,
      default: false,
    },
    iconClass: {
      type: String,
    },
    value: {
      type: String,
      default: undefined,
    },
    padding: {},
  },
});

export default PartOfSidebarMenu;
